import axios from 'axios'
import fetch from '@/utils/fetch'
// const apiConfig = require('../../static/config.json')
const fileLoadPath =window.Glob.BASE_URL;
const apiUrl = window.Glob.BASE_URL;


//角色
export function getRole(data) {
  return fetch({
    url: apiUrl + '/api/Role/GetRole?id='+data,
    method: 'post',
  })
}
export function getRoleBaseInfo(data) {
  return fetch({
    url: apiUrl + '/api/Role/GetRoleBaseInfo?id='+data,
    method: 'post'
  })
}
export function createRoleBaseInfo(data) {
  return fetch({
    url: apiUrl + '/api/Role/CreateRoleBaseInfo',
    method: 'post',
    data
  })
}

export function updateRoleBaseInfo(data) {
  return fetch({
    url: apiUrl + '/api/Role/UpdateRoleBaseInfo',
    method: 'post',
    data
  })
}

export function updateRoleAuthorization(data) {
  return fetch({
    url: apiUrl + '/api/Role/UpdateRoleAuthorization',
    method: 'post',
    data
  })
}

export function removeRole(data) {
  return fetch({
    url: apiUrl + '/api/Role/RemoveRole?id='+data,
    method: 'post'
  })
}

export function getRoleList(data) {
  return fetch({
    url: apiUrl + '/api/Role/GetRoleList',
    method: 'post',
    data
  })
}

export function addUserListToRole(data) {
  return fetch({
    url: apiUrl + '/api/Role/AddUserListToRole',
    method: 'post',
    data
  })
}

export function removeUserFormRole(data) {
  return fetch({
    url: apiUrl + '/api/Role/RemoveUserFormRole?roleId='+data.roleId+"&userId="+data.userId,
    method: 'post',
  })
}
// 角色结束


// WEBPACK FOOTER //
// ./src/api/roleApi.js